/**
 * Estructura Principal (Layout) para el Panel de Laboratorio.
 * Proporciona el marco visual institucional, incluyendo el encabezado, la barra lateral de navegación
 * y el contenedor principal para las diferentes vistas del dashboard de laboratorio.
 */

import React from "react";
import LabSidebar from "./LabSidebar";
// import NotificationsPanel from "../../shared/components/NotificationsPanel";
import "../../assets/css/DashboardAdmin.css"; // Se reutilizan estilos de administración para mayor cohesión visual
import logo from "../../assets/img/LogoGeo.png";

const LabLayout = ({ children, breadcrumb, title, currentView, setView }) => {
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

    return (
        <div className="admin-layout">
            {/* Fondo oscuro cuando la barra lateral está abierta en móviles */}
            <div className={`sidebar-backdrop ${isSidebarOpen ? 'show' : ''}`} onClick={() => setIsSidebarOpen(false)}></div>

            <LabSidebar
                currentView={currentView}
                setView={setView}
                isOpen={isSidebarOpen}
                toggle={() => setIsSidebarOpen(!isSidebarOpen)}
            />

            <main className="admin-main">
                {/* Encabezado Institucional GEOHCX */}
                <header className="admin-header shadow-sm bg-white" style={{ borderBottom: "4px solid #6B8E23" }}>
                    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                        <div className="d-flex align-items-center gap-3">
                            <button className="mobile-nav-toggle d-md-none" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                                <i className="bi bi-list"></i>
                            </button>
                            <div className="bg-light p-1 rounded border d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
                                <img src={logo} alt="Logotipo GEOHCX" style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }} />
                            </div>
                            <div>
                                <h5 className="m-0 fw-bold text-dark text-uppercase" style={{ letterSpacing: '1px' }}>GEOHCX</h5>
                                <small className="text-secondary text-uppercase" style={{ fontSize: '0.75rem' }}>Sistema de Vigilancia Epidemiológica</small>
                            </div>
                        </div>
                        <div className="text-end">
                            <div className="d-flex align-items-center gap-3">
                                <span className="badge bg-light text-dark border px-3 py-2 fw-normal">
                                    <i className="bi bi-person-workspace me-2"></i>
                                    Rol: <strong>Laboratorio Clínico</strong>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-end border-top pt-3">
                        <div>
                            <div className="admin-breadcrumb text-uppercase small text-muted mb-1" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                                {breadcrumb}
                            </div>
                            <h2 className="admin-title m-0 text-primary fw-bold">{title}</h2>
                        </div>
                        <div className="d-none d-md-block text-muted small text-end" style={{ maxWidth: '400px', fontSize: '0.8rem', fontStyle: 'italic' }}>
                            "La calidad del dato garantiza la eficiencia del control sanitario."
                        </div>
                    </div>
                </header>

                {/* Área de Contenido Dinámico */}
                <div className="admin-content-container py-4">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default LabLayout;
